<template>
  <div class="content">
    <navigate></navigate>
      <div class="header">
        <div class="header_main">
        <!-- 标题 -->
        <div class="header_title">
          <div class="header_title1">胜云会-企业会员服务</div>
          <div class="header_title2">为小微企业带来和谐的改变</div>
        </div>
        <!-- 扫码咨询 -->
        <div class="smzx"><div style="padding-top: 5px;">扫码咨询</div></div>
        <div class="smzx_right">
          <img src="../assets/img/right.png" />
        </div>
          <div class="ewm_bj">
        <div class="header_ewm">
          <img src="../assets/img/ewm.jpg" />
          </div>
        </div>
        <!-- 悬浮卡片 -->
        <div class="header_card">
          <!-- 卡片 -->
          <div class="card_1">
            <div class="card_1_1">
              <img src="../assets/img/1.png"/>
            </div>
            <div  class="card_1_2" >人事管理咨询</div>
            <div  class="card_1_3"></div>
            <div  class="card_1_4"><span>1对1解答人事问题</span><div style="width: 140px;">提升人事管理专业度</div></span></div>
          </div>
            <!-- 卡片 -->
          <div class="card_1">
            <div class="card_1_1">
              <img src="../assets/img/3.png"/>
            </div>
            <div  class="card_1_2" >劳动法规咨询</div>
            <div  class="card_1_3"></div>
            <div  class="card_1_4"><div style="margin-left: -30px">专业法律顾问</div><div >帮助规避用工风险</div></span></div>
          </div>
          <!-- 卡片 -->
            <div class="card_1">
            <div class="card_1_1">
              <img src="../assets/img/2.png"/>
            </div>
            <div  class="card_1_2" >招聘渠道拓展</div>
            <div  class="card_1_3"></div>
            <div  class="card_1_4" ><div style="margin-left: -30px">校园招聘对接</div><div >企业招聘信息发布</div></span></div>
          </div>
          <!-- 卡片 -->
            <div class="card_1">
            <div class="card_1_1">
              <img src="../assets/img/4.png"/>
            </div>
            <div  class="card_1_2"  style="width: 107px">政治咨询</div>
            <div  class="card_1_3"></div>
            <div  class="card_1_4"><div style="margin-left: -3px;">定向推送补贴资讯</div><div style="width: 150px;">人社业务申报快捷咨询</div></span></div>
          </div>
        </div>
        </div>
    </div>


    <!-- 中间部分 -->
    <div class="main">
      <div class="main_title1">
        <span style="font-size: 36px">企业会员权益</span>
        <div class="huqy">
          <div class="huqy_1"><div style="margin-top: 9px;">加入会员</div></div>
            <div class="huqy_2"><div  style="margin-top: 9px;">立享以下权益</div></div>
          <!-- <el-button-group class="first_but">
            <el-button>加入会员</el-button>
            <el-button>立享以下权益</el-button>
          </el-button-group> -->
        </div>
      </div>
      <div class="main_content">
        <div class="main_content1">
          <div class="main_content2">
            <span class="main_span1">人社业务咨询</span>
            <div class="main_icon">
              <div class="main_icon_item">
                <img src="../assets/img/5.png" />
              </div>
            </div>
            <span class="main_span2"
              >提供人社补贴测算方案<br /><div style="margin-top: 10px;">人社业务申报流程咨询</div></span
            >
          </div>
        </div>
        <div class="main_content1">
          <div class="main_content2">
            <span class="main_span1">用工风险咨询</span>
            <div class="main_icon">
              <div class="main_icon_item">
                <img src="../assets/img/6.png" />
              </div>
            </div>
            <span class="main_span2"
              >专业律师团队提供<br /><div style="margin-top: 10px;">劳动用工风险咨询</div></span
            >
          </div>
        </div>
        <div class="main_content1">
          <div class="main_content2">
            <span class="main_span1">企业招聘服务</span>
            <div class="main_icon">
              <div class="main_icon_item">
                <img src="../assets/img/7.png" />
              </div>
            </div>
            <span class="main_span2"
              >免费发布招聘需求<br /><div style="margin-top: 10px;">参加线上校园招聘会</div></span
            >
          </div>
        </div>
      </div>

      <div class="main_content">
        <div class="main_content1">
          <div class="main_content2">
            <span class="main_span1">政策早知道</span>
            <div class="main_icon">
              <div class="main_icon_item">
                <img src="../assets/img/8.png" />
              </div>
            </div>
            <span class="main_span2"
              >人社相关政策及时分享<br /><div style="margin-top: 10px;">人社惠企补贴早知道</div></span
            >
          </div>
        </div>
        <div class="main_content1">
          <div class="main_content2">
            <span class="main_span1">会员专享活动</span>
            <div class="main_icon">
              <div class="main_icon_item">
                <img src="../assets/img/9.png" />
              </div>
            </div>
            <span class="main_span2"
              >参加会员主题沙龙<br /><div style="margin-top: 10px;">参加人事课程活动</div></span
            >
          </div>
        </div>
        <div class="main_content1">
          <div class="main_content2">
            <span class="main_span1">福利产品团购</span>
            <div class="main_icon">
              <div class="main_icon_item">
                <img src="../assets/img/10.png" />
              </div>
            </div>
            <span class="main_span2"
              >会员尊享产品团购<br /><div style="margin-top: 10px;">（产品详情请咨询）</div></span
            >
          </div>
        </div>
      </div>

      <div class="main_title2">
        <span style="font-size: 36px">企业会员费</span>
          <div class="hyf">
          <div class="hyf_1">
            <div class="hyf_1_1">
               <img src="../assets/img/hy.png" />
            </div>
             <div class="hyf_1_2">
                <div>会员费</div>
                <div>￥2600/年</div>
             </div>
              <div class="hyf_1_3">   
              </div>
            <div  class="hyf_1_4"
            ><button class="hyf_but" @click="dialogVisible = true">立即开通</button></div> 
            <el-dialog
                title="请添加客服微信咨询"
                :visible.sync="dialogVisible"
                width="246px"
                >
                <img style="width: 200px;margin-top: -30px;margin-bottom: -30px;" src="../assets/img/ewm.jpg" />
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                </span>
              </el-dialog>
            </div>
           <div class="hyf_2">
            <div class="hyf_1_1">
               <img src="../assets/img/hy.png" />
            </div>
             <div class="hyf_1_2">
               <div>企业定制服务</div>
                <div>请咨询</div>
             </div>
              <div class="hyf_1_3"></div>
            <div  class="hyf_1_4"
            ><button class="hyf_but" @click="dialogVisible = true">立即咨询</button></div> 
          </div>
        </div>
      </div>

      <div class="main_content3">
        <div class="mcardTitle">
          会员尊享 <br/><div style="margin-top: 15px;">团购优惠</div>
        </div>
        <div class="lbCard" v-if="currentIndex<4"> 
          <div
            v-for="item in lbCardList"
            :key="item.id"
            :class="[item.id === currentIndex ? 'changeLbCard' : 'lbCard1']"
            v-show="item.id===0 || item.id===1 || item.id===2 || item.id===3"
          >
            <div class="lbCard1_1">
              <!-- <img :src="[item.id === currentIndex ? 'item.url1' : 'item.url']"/> -->
              <img v-if="item.id === currentIndex" :src="item.url1" />
              <img v-else :src="item.url" />
            </div>
            <div class="lbCard1_2">{{ item.title_1 }}</div>
            <div class="lbCard1_3">
              {{ item.title_2 }}<br /><div style="margin-top: 5px;">{{ item.title_3 }}</div>
            </div>
          </div>
        </div>
           <div class="lbCard"  v-else>
          <div
            v-for="item in lbCardList1"
            :key="item.id"
            :class="[item.id === currentIndex ? 'changeLbCard' : 'lbCard1']"
          >
            <div class="lbCard1_1">
              <!-- <img :src="[item.id === currentIndex ? 'item.url1' : 'item.url']"/> -->
              <img v-if="item.id === currentIndex" :src="item.url1" />
              <img v-else :src="item.url" />
            </div>
            <div class="lbCard1_2">{{ item.title_1 }}</div>
            <div class="lbCard1_3">
              {{ item.title_2 }}<br /><div style="margin-top: 5px;">{{ item.title_3 }}</div>
            </div>
          </div>
        </div>
        <div class="card-circle">
          <ul>
            <li
              @click="changeCard(item.id)"
              v-for="item in lbCardList"
              :key="item.id"
              :class="item.id === currentIndex ? 'active' : ''"
            ></li>
          </ul>
        </div>
      </div>
    </div>
      <!-- 底部 -->
    <div class="footer">
       <div class="fmian">
      <div class="footer_mian">
        <div class="foot_1">
          <div class="foot_logo">
            <img src="../assets/img/logo.png"/>
          </div>
          <div class="foot_title">人易宝企业服务品牌</div>
        </div>
        <div class="foot_2">
          <div class="foot_2_1">
            <img src="../assets/img/02.png"/>
          </div>
          <div class="foot_2_2"><span>会员服务微信</span></div>
          <div class="foot_2_3">
             <img src="../assets/img/ewm.jpg"/>
          </div>
        </div>
          <div class="foot_3">
          <div class="foot_2_1">
            <img src="../assets/img/01.png"/>
          </div>
          <div class="foot_2_2"><span>会员服务热线</span></div>
         <div class="foot_3_2">176-9581-0995</div>
        </div>
        <!-- <div class="foot_3">
          <span class="foot_3_1">会员服务热线</span>
          <div class="foot_3_2">176-9581-0995</div>
        </div> -->
        <div class="foot_2">
          <div class="foot_2_1">
             <img src="../assets/img/03.png"/>
          </div>
          <div class="foot_2_2"><span>扫码关注我们</span></div>
          <div class="foot_2_4"> 
            <img src="../assets/img/gz.png"/>
            </div>
        </div>
      </div>
      <div class="footer_foot">
        2016-2022&nbsp;&nbsp;天津人易宝智能科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;版权所有ICP备案：津ICP备14000167号-1
      </div>
    </div>
  </div>
 </div>
</template>

<script>
import Navigate from '../components/Navigate.vue';
export default {
  components: { Navigate },
  name: "XctUI",
  data() {
    return {
      dialogVisible: false,
      // lb:false,
      currentIndex: 0, //当前所在图片下标
      timer: null, //定时轮询
      lbCardList: [
        {
          id: 0,
          url: require("../assets/img/e.png"),
          url1: require("../assets/img/e1.png"),
          title_1: "电子劳动合同",
          title_2: "电子劳动合同签订与管理，",
          title_3: "规避风险，提高工作效率",
        },
        {
          id: 1,
          url: require("../assets/img/t.png"),
          url1: require("../assets/img/t1.png"),
          title_1: "体检服务",
          title_2: "会员企业享受团购优惠，",
          title_3: "企业团检礼品卡种类齐全",
        },
        {
          id: 2,
          url: require("../assets/img/q.png"),
          url1: require("../assets/img/q1.png"),
          title_1: "保险服务",
          title_2: "小企业团保险门槛低，见习",
          title_3: "保险、雇主险、补充医疗等",
        },
        {
          id: 3,
          url: require("../assets/img/w.png"),
          url1: require("../assets/img/w1.png"),
          title_1: "职业测评",
          title_2: "入职测评、晋升测评、阶",
          title_3: "段评价、多维度判断依据",
        },
        {
          id: 4,
        },
        {
          id: 5,
        },
        {
          id: 6,
        },
        {
          id: 7,
        },
      ],
      lbCardList1: [
        {
          id: 4,
          url: require("../assets/img/y.png"),
          url1: require("../assets/img/y1.png"),
          title_1: "招聘服务",
          title_2: "解决企业急聘人才问题",
          title_3: "提供到面、到岗、小猎产品",
        },
        {
          id: 5,
          url: require("../assets/img/i.png"),
          url1: require("../assets/img/i1.png"),
          title_1: "法律服务",
          title_2: "劳动用工风险咨询",
          title_3: "企业劳动争议案前调解",
        },
        {
          id: 6,
          url: require("../assets/img/a.png"),
          url1: require("../assets/img/a1.png"),
          title_1: "人社补贴代办",
          title_2: "企业人社补贴方案定制",
          title_3: "人社补贴申请代办",
          
        },
        {
          id: 7,
          url: require("../assets/img/d.png"),
          url1: require("../assets/img/d1.png"),
          title_1: "企业福利团购",
          title_2: "企业年节福利产品团购",
          title_3: "劳保产品批量定制",
          
        },
      ],
    };
  },
  methods: {
    startInterval() {
      // 事件里定时器应该先清除在设置，防止多次点击直接生成多个定时器
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.currentIndex++;
        if (this.currentIndex > this.lbCardList.length - 1) {
          this.currentIndex = 0;
        }
      }, 3000);
    },
    // 点击控制圆点
    changeCard(index) {
      this.currentIndex = index;
    },
    //鼠标移入移出控制
    changeInterval(val) {
      if (val) {
        clearInterval(this.timer);
      } else {
        this.startInterval();
      }
    },
  },
  //进入页面后启动定时轮播
  mounted() {
    this.startInterval();
  },
};
</script>
<style >
*{
  margin: 0;
  padding: 0;
}
body{
  padding-right: 0 !important ;
}
</style>
<style scoped>
.content {
  width: 100%;
  margin: 0;
}
.changeLbCard {
  background: #1edc86;
  width: 210px;
  height: 257px;
  margin: 100px 16px;
  color: #fff;
}
/* 控制圆点 */
.card-circle ul li {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 0 5px;
  border-radius: 7px;
  background-color: #fff;
  cursor: pointer;
  border-radius: 50%;
}
.card-circle {
      width: 300px;
    height: 32px;
    position: absolute;
    margin-top: 490px;
    margin-left: 439px;
}

.header {
  height: 504px;
  width: 100%;
  background:#313A5B;
  margin: 0;
  /* background-size: 100% 100%; */
  /* background: orange; */
}
.header_main {
  height: 504px;
  width: 1280px;
  background-image: url(../assets/img/banner.png);
  background-size: 100% 100%;
  text-align: center;
   margin: 0 auto;
  /* background: orange; */
}
.header_title {
  /* background: pink; */
  width: 632px;
  height: 110px;

}
.header_ewm {
  width: 105px;
  height: 105px;
  margin-left: 18px;
  margin-top: 21px;
}
.ewm_bj {
  /* position: absolute; */
  background-image: url(../assets/img/wx.png);
     width: 140px;
    height: 140px;
    margin-left: 1060px;
    margin-top: -156px;
    background-size: 100%;
}
.header_ewm img {
  width: 100px;
  height: 100px;
      margin-top: 20px;
}
.header_card {
     width: 1115px;
    background: #fff;
    height: 335px;
    margin-top: 34px;
    margin-left: 83px;
    border-radius: 20px;
    display: flex;
    border-bottom: 1px solid #bbb;
}
.card_1 {
  width: 126px;
  height: 243px;
  /* background: yellow; */
  margin: 50px 80px 10px 80px;
}
.card_1_1 {
  /* background: #1edc86; */
  width: 80px;
  height: 80px;
}
.card_1_1 img {
  width: 80px;
}
.card_1_2 {
  width: 138px;
  height: 32px;
  margin: 20px 0px;
  font-size: 20px;
  margin-left: -10px;
}
.card_1_3 {
  width: 118px;
  height: 10px;
  background: #1edd86;
  border-radius: 5px;
}
.card_1_4 {
  margin-top: 26px;
  width: 124px;
  height: 42px;
  font-size: 15px;
}
.main {
  height: 2153px;
  width: 1280px;
  padding-top: 230px;
text-align: center;
   margin: 0 auto;
}
.main_content {
  width: 1280px;
  height: 450px;
  display: flex;
}
.main_content1 {
  /* background: pink; */
  width: 352px;
  height: 407px;
  margin-top: 50px;
  margin-left: 55px;
}
.main_content1:hover {
  box-shadow: 0px 10px 10px 2px #888888;
}
.main_title2 {
  text-align: center;
  /* background: pink; */
margin-top: 70px;
  margin-bottom: 378px;
}
.main_content3 {
  background-image: url(../assets/img/zz.png);
  background-size: 100% 100%;
  width: 1280px;
  height: 690px;
  display: flex;
  margin-top: -317px;
  /* background: pink; */
}
.main_content2 {
  width: 200px;
  height: 280px;

  margin: 70px;
}
.main_span1 {
  font-size: 27px;
}
.main_span2 {
  font-size: 19px;
}
.main_icon {
  /* background: blueviolet; */
  text-align: center;
  width: 200px;
  height: 177px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main_icon_item {
  /* background: pink; */
  /* background: yellow; */
  width: 60px;
  height: 60px;
}

.footer {
  height: 280px;
  width: 100%;
  background: #eff1f2;
}
.fmian{
   height: 280px;
  width:1280px;
  background: #eff0f2;
  text-align: center;
   margin: 0 auto;
}
.el-button-group {
  border: 1px solid #a4d48c;
  border-radius: 4px;
}
.first_but {
  margin-top: 40px;
}

.footer_mian {
  width: 1220px;
  /* background: yellow; */
  height: 185px;
  margin-left: 30px;
  margin-top: 40px;
  border-bottom: 1px solid #e4e4e4;
  display: flex;
}
.footer_foot {
  width: 1280px;
  /* background: blue; */
  height: 40px;
  text-align: center;
  margin-top: 20px;
  font-size: 15px;
  color: #999;
}
.foot_1 {
  width: 300px;
  /* background: pink; */
  height: 100px;
  margin: 40px 0px;
  border-right: 2px solid #c0c4cc;
}
.foot_logo {
  width: 300px;

  height: 100px;
}
.foot_logo img {
  margin-top: -124px;
  margin-left: -136px;
}
.foot_title {
      font-size: 20px;
    margin-top: -40px;
    margin-left: 7px;
}
.foot_2 {
  width: 250px;
  /* background: pink; */
  height: 135px;
  margin: 30px 60px;
}
.foot_3 {
  width: 250px;
 
  height: 135px;
 
  /* background: pink; */
  height: 73px;
  margin: 30px 0px;
}
.foot_3_1 {
  font-size: 20px;
}
.foot_3_2 {
  font-size: 21px;
  margin-top: 10px;
  margin-left: 25px;
}
.foot_2_1 {
  position: absolute;
  width: 60px;
  height: 60px;
  /* background: gainsboro; */
}
.foot_2_1 img {
  width: 45px;
}
.foot_2_2 {
  margin-top: 12px;
  font-size: 20px;
  margin-left: 30px;
}
.foot_2_3 {
  position: absolute;
  width: 80px;
  height: 80px;
  /* background: aliceblue; */
  margin-left: 87px;
  margin-top: 5px;
}
.foot_2_3 img {
  width: 80px;
}
.foot_2_4 img {
  width: 80px;
}
.foot_2_4 {
  position: absolute;
  width: 80px;
  height: 80px;
  background: aliceblue;
  margin-left: 87px;
  margin-top: 5px;
}
.lbCard1 {
  background: #ffffff;
  width: 210px;
  height: 257px;
  margin: 100px 16px;
}
.lbCard1_1 {
  width: 60px;
  height: 60px;
  /* background: blueviolet; */
  position: absolute;
  margin-top: 38px;
  margin-left: 80px;
}
.lbCard1_2 {
  width: 130px;
  height: 35px;
  /* background: green; */
  position: absolute;
  margin-left: 45px;
  margin-top: 111px;
  font-size: 21px;
}
.lbCard1_3 {
  width: 180px;
  height: 53px;
  /* background: navajowhite; */
  position: absolute;
  margin-top: 160px;
  margin-left: 18px;
  font-size: 15px;
}
.lbCard {
  display: flex;
  margin-left: 310px;
  margin-top: 80px;
}
.active {
  background-color: #1edc86 !important;
}
.header_title1 {
  font-size: 50px;
    color: #fff;
    margin-left: 20px;
    padding-top: 151px;
}
.header_title2 {
  margin-top: 10px;
  font-size: 21px;
  color: #fff;
  margin-left: -201px;
}
.hyf {
  margin-top: 40px;
}
.hyf_1 {
     width: 231px;
    height: 294px;
    font-size: 22px;
    color: #fff;
    /* background: pink; */
    border: none;
    /* position: absolute; */
    margin-left: 370px;
    box-shadow: 0px 10px 10px 2px #e4e4e4;

    }
    .hyf_2 {
   width: 231px;
    height: 294px;
    font-size: 22px;
    color: #fff;
    border: none;
    margin-left: 669px;
    box-shadow: 0px 10px 10px 2px #e4e4e4;
    margin-top: -343px;
}
    .hyf_1_1{
    width: 49px;
    height: 49px;
    background: #313A5B;
    margin-left: 90px;
    margin-top: 50px;
    border-radius: 10px;
    
    }
   .hyf_1_1 img {
      width: 37px;
    margin-top: 6px;
    }
      .hyf_1_2{
       width: 130px;
    height: 56px;
    /* background: #fff; */
    margin-top: 47px;
    margin-left: 52px;
    color: black;
    font-size: 20px;
    }
      .hyf_1_3{
         width: 22px;
    height: 4px;
    background: black;
    margin-left: 105px;
    margin-top: 15px;
    }
      .hyf_1_4{
         width: 231px;
    height: 36px;
    /* background: yellow; */
    margin-top: 20px;
    
    }
    .hyf_but{
    width: 168px;
    height: 32px;
    background: #1edc86;
    border-radius: 19px;
    color: #fff;
    font-size: 15px;
    border: #1edc86;
    cursor: pointer;
    outline: none;
    }

.mcardTitle {
  /* background: #1edc86; */
  width: 150px;
  height: 117px;
  position: absolute;
 margin-left: 120px;
  top: 2370px;
  font-size: 36px;
}
.smzx {
    width: 139px;
    height: 38px;
    background: #307a85;
    margin-left: 877px;
    margin-top: 160px;
    font-size: 21px;
    color: #fff;
    border-radius: 8px;
}
.smzx_right img {
  width: 33px;
}

.smzx_right{
     width: 33px;
    height: 38px;
    margin-left: 1022px;
    margin-top: -36px;
}
.huqy {
  width: 403px;
  height: 58px;
  /* background: #ebeef5; */
  margin-left: 450px;
  margin-top: 30px;
  cursor: pointer;
}
.huqy_1 {
  width: 165px;
  height: 58px;
  background: #f4f4f4;
  margin-left: 1px;
  border-radius: 10px 0px 0px 10px;
  border: 1px solid #34c882;
  font-size: 27px;
}
.huqy_2 {
  width: 236px;
  height: 58px;
  background: #f0fdf6;
  margin-left: 167px;
  border-radius: 0px 10px 10px 0px;
  border: 1px solid #34c882;
  margin-top: -60px;
  font-size: 27px;
}

</style>
